import { render, staticRenderFns } from "./iOS-app.vue?vue&type=template&id=19b43f25&scoped=true&"
import script from "./iOS-app.vue?vue&type=script&lang=js&"
export * from "./iOS-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b43f25",
  null
  
)

export default component.exports